import { useCallback } from "react";

export enum PostMessageStatus {
  SUCCESS = "Unu Health check successful",
  FAILURE = "Unu Health check unsuccessful",
  CLOSE_TAB = "Unu Health check close tab",
}

/**
 * Note: This function is designed for use when the app is hosted within an iframe,
 * enabling communication with the parent window through postMessage.
 *
 * Sends a message to the parent window with the given status.
 * The message is sent with the origin of the parent window's
 * referrer, if it matches one of the allowed origins.
 * If no allowed origins are configured, an error is thrown.
 */
export function usePostMessageToParent() {
  const allowedOrigins: string[] = (
    import.meta.env.VITE_APP_ALLOWED_ORIGINS || ""
  )
    .split(",")
    .map((origin: string) => origin.trim())
    .filter(Boolean);

  if (allowedOrigins.length === 0) {
    throw new Error("No allowed origins configured.");
  }

  return useCallback((status: PostMessageStatus) => {
    const targetOrigin = allowedOrigins.find((origin) =>
      window.document.referrer.startsWith(origin)
    ) as string;

    const message = { type: "FROM_IFRAME", payload: { status } };

    if (window.parent) {
      window.parent.postMessage(message, targetOrigin);
    }
  }, []);
}
